import { MenuStyle } from "./style";
import { Avatar, MenuItem, Typography } from "@mui/material";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link } from "react-router-dom";
import { AppContext } from "../../scripts/context/App";
import { useContext } from "react";

export default function DropMenu({ anchorElUser, setAnchorElUser }: any) {
  const { user, logout } = useContext(AppContext);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  return (
    <MenuStyle
      sx={{
        mt: "45px",
        ".MuiButtonBase-root:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.15)",
        },
      }}
      id="menu-appbar"
      anchorEl={anchorElUser}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(anchorElUser)}
      onClose={handleCloseUserMenu}
    >
      <MenuItem className="avatar-name">
        <Avatar alt={user.full_name} src={user.avatar} />
        <Typography textAlign="center">{user.full_name}</Typography>
      </MenuItem>
      <Link
        to={`/dashboard/profile`}
        style={{
          textDecoration: "none",
          color: "inherit",
        }}
      >
        <MenuItem className="profile" onClick={handleCloseUserMenu}>
          <Typography textAlign="center">
            <PermIdentityIcon />
            Profile
          </Typography>
        </MenuItem>
      </Link>
      <hr />
      <Link
        to="/dashboard/support-tickets"
        style={{
          textDecoration: "none",
          color: "inherit",
        }}
      >
        <MenuItem className="profile" onClick={handleCloseUserMenu}>
          <Typography textAlign="center">
            <HelpOutlineIcon />
            Help Center
          </Typography>
        </MenuItem>
      </Link>
      <MenuItem onClick={logout} className="profile">
        <Typography textAlign="center">
          <LogoutIcon />
          Sign Out
        </Typography>
      </MenuItem>
    </MenuStyle>
  );
}
